import type {Action} from "@App/state/actions";
import {ActionType} from "@App/state/action-types";
import {DriverDataSuccessResponse} from "@App/apis/rest/ayvens/driverData/driverDataSuccessResponse";

interface AuthReducerState {
    userId: string|null
    driverData: DriverDataSuccessResponse|null
}

const initialState: AuthReducerState = {
    userId: null,
    driverData: null,
}

const authReducer = (state: AuthReducerState = initialState, action: Action) => {
    switch (action.type) {
        // modal actions
        case ActionType.SET_USER_ID:
            return {
                ...state,
                userId: action.payload
            }
        case ActionType.SET_DRIVER_DATA:
            return {
                ...state,
                driverData: action.payload
            }
    }
    return state
}

export default authReducer
